import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';

import type { ReferralsCondition } from '../types';

@Injectable({ providedIn: 'root' })
export class ConditionsHttpService {
  private readonly httpApi = inject(HttpApiService);

  public loadConditions(): Observable<ReferralsCondition[]> {
    return this.httpApi.get('/conditions').pipe(map(data => data.conditions));
  }
}
